import { IonBadge, IonIcon, IonItem, IonLabel, IonText } from "@ionic/react";
import { calculateDuration, formatNumber, utcToLocalTime } from "@/utils";
import { Planning } from "@/api";
import { checkmarkCircleOutline } from "ionicons/icons";

export interface DayPlanningCardProps {
  item: Planning;
  onClick?: () => void;
}

export default function DayPlanningCard({
  item,
  onClick,
}: DayPlanningCardProps) {
  let addressLine1 = item.project?.client?.address_json?.street || "";
  if (item.project?.client?.address_json?.city) {
    addressLine1 +=
      (addressLine1 ? ", " : "") + item.project.client.address_json.city;
  }

  return (
    <IonItem key={item.id} button={!!onClick} onClick={onClick}>
      <IonLabel>
        <IonText color="primary">
          <span className="tw:text-xs ">
            {utcToLocalTime(item.start_time)} - {utcToLocalTime(item.end_time)}
          </span>
        </IonText>

        {item.project && (
          <>
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              {item.project.status === "completed" && (
                <IonIcon icon={checkmarkCircleOutline} color="success" />
              )}
              <IonText color="dark" className="tw:text-sm tw:font-medium">
                {item.project.name}
              </IonText>
            </div>

            {item.project.client && (
              <IonText color="medium">
                <p className="tw:text-xs">{item.project.client.name}</p>
                {addressLine1 && <p className="tw:text-xs">{addressLine1}</p>}
              </IonText>
            )}
          </>
        )}
      </IonLabel>

      <IonBadge slot="end" color="primary">
        {formatNumber(calculateDuration(item.start_time, item.end_time))} uur
      </IonBadge>
    </IonItem>
  );
}
